import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Company',
    column_type: 'id',
    label_key_path: 'company.id',
  },
  created_at: {
    model_name: 'Company',
    column_type: 'datetime',
    label_key_path: 'company.createdAt',
  },
  updated_at: {
    model_name: 'Company',
    column_type: 'datetime',
    label_key_path: 'company.updatedAt',
  },
  name: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.name',
  },
  jushuitan_supplier_id: {
    model_name: 'Company',
    column_type: 'integer',
    label_key_path: 'company.jushuitanSupplierId',
  },
  cutting_threshold_percent: {
    model_name: 'Company',
    column_type: 'integer',
    label_key_path: 'company.cuttingThresholdPercent',
  },
  cutting_grace_hours: {
    model_name: 'Company',
    column_type: 'integer',
    label_key_path: 'company.cuttingGraceHours',
  },
  abilities: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.abilities',
  },
  order_limit: {
    model_name: 'Company',
    column_type: 'integer',
    label_key_path: 'company.orderLimit',
  },
  order_usage_rate: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.orderUsageRate',
  },
  on_the_way_orders_count: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.onTheWayOrdersCount',
  },
  on_the_way_orders_cost: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.onTheWayOrdersCost',
  },
  overdue_rate: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.overdueRate',
  },
  liquidated_damages: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.liquidatedDamages',
  },
  return_rate: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.returnRate',
  },
  current_month_rating: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.currentMonthRating',
  },
  current_quarter_rating: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.currentQuarterRating',
  },
  current_year_rating: {
    model_name: 'Company',
    column_type: 'string',
    label_key_path: 'company.currentYearRating',
  },
  merchandisers: {
    model_name: 'Company',
    column_type: 'has_many',
    label_key_path: 'company.merchandisers',
    extra: {
      association_name: 'merchandisers',
      model_name: 'User',
      foreign_key: 'user_id',
      display_column: 'screen_name',
    },
  },
  merchandiser_ids: {
    model_name: 'Company',
    column_type: 'has_many',
    label_key_path: 'company.merchandisers',
    extra: {
      association_name: 'merchandisers',
      model_name: 'User',
      foreign_key: 'user_id',
      display_column: 'screen_name',
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
